import { mergeMap } from 'rxjs';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AdjustmentProfileAction } from '../adjustmentProfile.action';

export const removeAdjustmentEpic: IEpic<{}, IClientApiDependencySegment> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.remove.started),
  mergeMap((params) => dependencies.api.deleteAdjustmentProfile({ id: params.adjustmentId }).pipe(
    mergeMap(() => {
      return [AdjustmentProfileAction.remove.done({ params })];
    }),
    catchApiError((error) => {
      return [
        AdjustmentProfileAction.remove.failed({ error: null, params }),
        createApiErrorNotification(error),
      ];
    }),
  )),
);
